import React, { useEffect, useState } from "react";
import { DatePicker, Input, Table, TimePicker } from "antd";
import { useParams } from "react-router-dom";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import dayjs from "dayjs";

const ViewBunkerReport = () => {
  const { bunkerLog_id } = useParams();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [staff_dashboard, set_staff_dashboard] = useState('');
  const [date, set_Date] = useState();
  const [time, set_Time] = useState();
  const [place, set_Place] = useState("");
  const [trim, set_Trim] = useState("");

  const LIST_SUB_TANKS_API = () => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      const staff_Details = JSON.parse(localStorage.getItem("user_data"));
      FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
      FORM_DATA.append("record_id", atob(bunkerLog_id));
      post(ApiURL.view_bunker_tank_entries, FORM_DATA).then((res) => {
        if (res?.status === true) {
          set_page_loader(false);
          setFilteredData(res?.entry?.tank_data);
          set_Date(dayjs(res?.entry?.log_date));
          set_Time(dayjs(res?.entry?.log_time, "HH:mm:ss"));
          set_Place(res?.entry?.place);
          set_Trim(res?.entry?.trim);
        }
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    LIST_SUB_TANKS_API();
  }, []);

  const columns = [
    {
      title: "Tank ID",
      dataIndex: "tank_id",
      align: "center",
      key: "tank_id",
    },
    {
      title: "Tank Name",
      dataIndex: "tank_name",
      align: "center",
      key: "tank_name",
    },
    {
      title: "Grade",
      dataIndex: "category_name",
      align: "center",
      key: "category_name",
    },
    {
      title: "Capacity (m3)",
      dataIndex: "capacity",
      align: "center",
      key: "capacity",
    },
    {
      title: "Ullage cm/ sounding cm",
      dataIndex: "ullage",
      align: "center",
      key: "ullage",
    },
    {
      title: "QTTY (M3)",
      dataIndex: "volume",
      align: "center",
      key: "volume",
    },
    {
      title: "Density @ 15 deg",
      dataIndex: "density",
      align: "center",
      key: "density",
    },
    {
      title: "TK Temp (Deg C)",
      dataIndex: "temperature",
      align: "center",
      key: "temperature",
    },
    
     {
      title: "Sulphur %",
      dataIndex: "sulphur",
      align: "center",
      key: "sulpur",
    },
    {
      title: "QTTY (MT)",
      dataIndex: "rob_qty_mt",
      align: "center",
      key: "rob_qty_mt",
      render: (text, record) => (record._isSubtotal ? ` ${text}` : text),
    },
      
  ];

  const groupByCategoryWithSubtotals = (data) => {
    const grouped = {};
    data.forEach((item) => {
      const category = item.category_name || "Unknown";
      if (!grouped[category]) grouped[category] = [];
      grouped[category].push({ ...item, _isSubtotal: false });
    });
    Object.entries(grouped).forEach(([category, items]) => {
      const totalRob = items.reduce(
        (sum, item) => sum + parseFloat(item.rob_qty_mt || 0),
        0
      );
      const totalvolume = items.reduce(
        (sum, item) => sum + parseFloat(item.volume || 0),
        0
      );
      

      grouped[category].push({
        // tank_id: `total-${category}`,
        tank_name: "",
        // category_name: category,
        capacity: "",
        volume:totalvolume.toFixed(2),
        rob_qty_mt: totalRob.toFixed(2),
        _isSubtotal: true,
        vcf:"Total",
      });
    });

    return grouped;
  };

  const groupedData = groupByCategoryWithSubtotals(filteredData);

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />

      <h3>Bunker Record Information</h3>

      <div
        style={{
          display: "flex",
          gap: "20px",
          marginTop: "15px",
          marginBottom: "15px",
        }}
      >
        <div style={{flex:1}}>
          <b>Date</b>
          <br />
          <DatePicker style={{width:"100%"}} value={date} disabled />
        </div>
        <div style={{flex:1}}>
          <b>Time</b>
          <br />
          <TimePicker value={time} disabled style={{width:"100%"}}/>
        </div>
        <div style={{flex:1}}>
          <b>Place</b>
          <Input value={place} disabled  />
        </div>
        <div style={{flex:1}}>
          <b>Trim</b>
          <Input value={trim} disabled  />
        </div>
      </div>

      {Object.entries(groupedData).map(([category, items]) => (
        <div key={category} style={{ marginBottom: "30px" }}>
          <h4 style={{ fontWeight: "bold", marginTop: "20px",marginBottom:"20px" }}>
            Fuel Type: {category}
          </h4>
          <Table
            bordered
            columns={columns}
            dataSource={items}
            pagination={false}
            rowKey={(record, index) => record.tank_id + index}
            loading={page_loader}
            className="custom-table"
            rowClassName={(record) =>
              record._isSubtotal ? "subtotal-row" : ""
            }
          />
        </div>
      ))}
    </>
  );
};

export default ViewBunkerReport;
